import { graphql } from 'gql/generated'

export const GET_PARTNERS_PAYMENTS_SUMMARY = graphql(`
  query GetPartnersPaymentsSummary($input: PartnersPaymentSummariesInput, $pagination: PaginationV2) {
    partnersPaymentSummaries(input: $input, pagination: $pagination) {
      total
      items {
        id
        name
        status
        startDate
        endDate
        files {
          id
          category
          errorsFilePath
        }
        timeline {
          id
          correlationID
          type
          createdAt
          user {
            id
            firstName
            lastName
            username
          }
          action {
            ... on PartnersPaymentSummaryTimelineEventActionFilesUploaded {
              files {
                id
                category
                path
              }
            }
          }
        }
        emails {
          id
          address
          status
          reason
          updatedAt
          partner {
            id
            name
          }
        }
      }
    }
  }
`)

export const GET_PARTNERS_PAYMENT_SUMMARY = graphql(`
  query GetPartnersPaymentSummary($input: PartnersPaymentSummaryInput!) {
    partnersPaymentSummary(input: $input) {
      id
      name
      status
      startDate
      endDate
      files {
        id
        category
        errorsFilePath
      }
      emails {
        id
        address
        status
        reason
        updatedAt
        partner {
          id
          name
        }
        vehicle {
          id
          name
          externalID
        }
      }
    }
  }
`)
